import * as React from "react";
import Config from "../../Config";

/**
 * Parent component that filter components inherit from
 */
export default class FilterCheck extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            aSelectedItems: [],
            aDefaultSelected: []
        };

        this.state.aDefaultSelected = this.props.aDefaultSelected;

        Config.getConfig();
    }

    /**
     * After item was selected/deselected it is added or removed from selected items
     * @param {Object} aEvent 
     * @param {Object} aExtra 
     */
    handleChange = (aEvent, aExtra) =>
    {

        if (aEvent.target.checked)
        {
            // add selection's string or object with extra data

            if (this.props.singleSelection)
            {
                this.state.aSelectedItems = [];
            }
            if (aExtra)
            {
                this.state.aSelectedItems.push({
                    extra: aExtra,
                    name: aEvent.target.name,
                    direction: aExtra.direction
                })
            } else
            {
                this.state.aSelectedItems.push(aEvent.target.name);
            }
        } else
        {
            // find deselected item and remove it from selected items

            var nIndex = null;
            if (aExtra)
            {
                nIndex = this.state.aSelectedItems.findIndex(aItem => (aItem.name === aEvent.target.name));
            } else
            {
                nIndex = this.state.aSelectedItems.indexOf(aEvent.target.name);
            }
            this.state.aSelectedItems.splice(nIndex, 1);
        }
        this.setState({});
    }

    /**
     * Get the selection
     */
    getSelection = () =>
    {
        return this.state.aSelectedItems;
    }
}
